import { render, staticRenderFns } from "./TermsTab.vue?vue&type=template&id=bc7e978c&scoped=true&"
import script from "./TermsTab.vue?vue&type=script&lang=ts&"
export * from "./TermsTab.vue?vue&type=script&lang=ts&"
import style0 from "./TermsTab.vue?vue&type=style&index=0&id=bc7e978c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7e978c",
  null
  
)

export default component.exports